import React from 'react';
import { 
    Card, 
    CardContent, 
    Stack, 
    Skeleton, 
    Box 
} from '@mui/material';

const ITUserActionCardSkeleton: React.FC = () => {
    return (
        <Card
            sx={{
                backgroundColor: '#FAF9F9',
                borderRadius: '16px',
                boxShadow: '0px 4px 12px rgba(0,0,0,0.05)',
                border: '2px solid #E0E0E0'
            }}
        >
            <CardContent>
                <Stack spacing={1}>
                    {/* Action */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={60}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 0.5 }}
                        />
                        <Skeleton
                            variant="text"
                            width={100}
                            height={20}
                            sx={{ backgroundColor: '#f0f0f0' }}
                        />
                    </Box>

                    {/* Message */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={70}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 0.5 }}
                        />
                        <Skeleton
                            variant="text"
                            width={140}
                            height={20}
                            sx={{ backgroundColor: '#f0f0f0' }}
                        />
                    </Box>

                    {/* User */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={50}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 0.5 }}
                        />
                        <Skeleton
                            variant="text"
                            width={80}
                            height={20}
                            sx={{ backgroundColor: '#f0f0f0' }}
                        />
                    </Box>

                    {/* Roles */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={50}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 1 }}
                        />
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            <Skeleton
                                variant="rectangular"
                                width={80}
                                height={24}
                                sx={{
                                    borderRadius: '6px',
                                    backgroundColor: '#f0f0f0'
                                }}
                            />
                            <Skeleton
                                variant="rectangular"
                                width={100}
                                height={24}
                                sx={{
                                    borderRadius: '6px',
                                    backgroundColor: '#f0f0f0'
                                }}
                            />
                            <Skeleton
                                variant="rectangular"
                                width={90}
                                height={24}
                                sx={{
                                    borderRadius: '6px',
                                    backgroundColor: '#f0f0f0'
                                }}
                            />
                        </Box>
                    </Box>

                    {/* Timestamp */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width={80}
                            height={16}
                            sx={{ backgroundColor: '#f0f0f0', mb: 0.5 }}
                        />
                        <Skeleton
                            variant="text"
                            width={120}
                            height={20}
                            sx={{ backgroundColor: '#f0f0f0' }}
                        />
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default ITUserActionCardSkeleton;
